import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { HelmetProvider } from "react-helmet-async";
import "./styles/global.scss";
import App from "./App";
import theme from "./theme/muiTheme";
import { createRoot, hydrateRoot } from "react-dom/client";

const rootElement = document.getElementById("root");
const app = (
  <HelmetProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
